import type { SVGProps } from 'react';
const SvgTelegramTypeLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={60}
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <rect width={60} height={60} fill="#33A4EB" rx={8} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M14.978 28.054q13.53-5.928 18.043-7.815C41.613 16.645 43.398 16.02 44.562 16c.256-.004.828.06 1.199.362.313.255.4.6.44.843.041.242.093.793.052 1.224-.466 4.92-2.48 16.858-3.505 22.368-.434 2.33-1.288 3.113-2.115 3.19-1.796.165-3.16-1.195-4.9-2.342-2.724-1.795-4.262-2.912-6.905-4.664-3.055-2.024-1.075-3.136.666-4.955.456-.475 8.372-7.716 8.525-8.373.02-.082.037-.388-.144-.55-.18-.161-.448-.106-.64-.062q-.411.093-13.05 8.674-1.854 1.278-3.356 1.246c-1.105-.024-3.23-.628-4.81-1.145-1.937-.633-3.477-.968-3.343-2.043q.105-.84 2.302-1.72"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTelegramTypeLarge;
